export const getTheme = (theme) => {
    return (dispatch) => {
        dispatch({
            type: "GET_THEME",
            theme: theme,
        });

    }
}